import { RichTextParser } from '@PetSureAustralia/petsure-react-ui-library/distLib/helpers';
import { CSPUrlsMap } from '../../../routes/CSPUrlsMap';
import { daysUntil } from '../../../utils/date';
import { replacePlaceholdersMultiplePatterns } from '../../../services/cms/HtmlResolver';
import { findByTaxonomyCodename } from '../../../utils/kontentAi/find';
import { BANNER_BUTTON_TAXONOMY_KEY, BANNER_MESSAGE_TAXONOMY_KEY, TAG_PATTERNS } from '../consts';

export const getBanners = (eligibilityData, contentData, cmsTagsData, singleBanner) => {
  return eligibilityData?.map((item) => {
    const messageObject = findByTaxonomyCodename(
      contentData.messageVariants,
      BANNER_MESSAGE_TAXONOMY_KEY,
      item?.RenewalStatus?.toLowerCase()
    );
    const bodyContent = messageObject?.elements?.message_text?.value;

    const buttonObject = findByTaxonomyCodename(
      contentData.buttonVariants,
      BANNER_BUTTON_TAXONOMY_KEY,
      item?.RenewalStatus?.toLowerCase()
    );
    const hideRenewButton = singleBanner && !item.CanRenewPolicy;
    const actionLabel = hideRenewButton ? undefined : buttonObject?.elements?.button_text?.value;

    const daysUntilExpiry = daysUntil(item.ExpiryDate);
    const contentPlaceholderValues = { ...item, ...cmsTagsData, csp_daysToExpiry: daysUntilExpiry };

    const body = RichTextParser(
      replacePlaceholdersMultiplePatterns(bodyContent, contentPlaceholderValues, TAG_PATTERNS, false)
    );

    const redirectUrl = `${item.CanRenewPolicy ? CSPUrlsMap.renewalHub.url : CSPUrlsMap.myPets.url}?policy=${
      item.PolicyNumber
    }`;

    const icon = 'warning';

    const variant = `warning`;

    return {
      body,
      actionLabel,
      redirectUrl,
      icon,
      variant,
      policyNumber: item.PolicyNumber,
      renewalStatus: item?.RenewalStatus?.toLowerCase(),
      canRenew: !!item.CanRenewPolicy,
      daysToExpiry: daysUntilExpiry
    };
  });
};
